A non-negative limit to the number of job categories to return.

Defaults to 10.
